var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineNotificationModalImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 181,
    height: 161,
    viewBox: "0 0 181 161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_16",
    "data-name": "\\u9577\\u65B9\\u5F62 16",
    width: 181,
    height: 161,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illust",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_1",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_137",
    "data-name": "\\u30D1\\u30B9 137",
    d: "M99.448,7.158A6.891,6.891,0,1,0,106.34.284a6.882,6.882,0,0,0-6.892,6.874",
    transform: "translate(62.967 0.178)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_138",
    "data-name": "\\u30D1\\u30B9 138",
    d: "M99.448,7.158A6.891,6.891,0,1,0,106.34.284,6.882,6.882,0,0,0,99.448,7.158Z",
    transform: "translate(62.967 0.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_139",
    "data-name": "\\u30D1\\u30B9 139",
    d: "M8.132,102.739H173.578a4.941,4.941,0,0,0,4.932-4.92V96.784a4.941,4.941,0,0,0-4.932-4.92H8.132A4.941,4.941,0,0,0,3.2,96.784v1.035a4.941,4.941,0,0,0,4.932,4.92",
    transform: "translate(2.026 57.799)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_7",
    "data-name": "\\u9577\\u65B9\\u5F62 7",
    width: 175.31,
    height: 10.875,
    rx: 3.02,
    transform: "translate(5.226 149.663)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_140",
    "data-name": "\\u30D1\\u30B9 140",
    d: "M96.047,49.4,67.806,77.812v33.249h-19.7V75.211a16.156,16.156,0,0,1,4.034-10.678L65.464,49.4Z",
    transform: "translate(30.459 31.082)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_141",
    "data-name": "\\u30D1\\u30B9 141",
    d: "M96.047,49.4,67.806,77.812v33.249h-19.7V75.211a16.156,16.156,0,0,1,4.034-10.678L65.464,49.4Z",
    transform: "translate(30.459 31.082)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_142",
    "data-name": "\\u30D1\\u30B9 142",
    d: "M41.313,95.619h0a4.591,4.591,0,0,1,4.6-4.586h6.5V87.248h19.7V100.2H45.91a4.591,4.591,0,0,1-4.6-4.586",
    transform: "translate(26.158 54.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_143",
    "data-name": "\\u30D1\\u30B9 143",
    d: "M41.313,95.619h0a4.591,4.591,0,0,1,4.6-4.586h6.5V87.248h19.7V100.2H45.91A4.591,4.591,0,0,1,41.313,95.619Z",
    transform: "translate(26.158 54.895)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_144",
    "data-name": "\\u30D1\\u30B9 144",
    d: "M106.82,95.181h0a5,5,0,0,1-5.009-5V84.116H98.017V64.461h13.812V90.184a5,5,0,0,1-5.009,5",
    transform: "translate(62.061 40.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_145",
    "data-name": "\\u30D1\\u30B9 145",
    d: "M106.82,95.181h0a5,5,0,0,1-5.009-5V84.116H98.017V64.461h13.812V90.184A5,5,0,0,1,106.82,95.181Z",
    transform: "translate(62.061 40.558)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_146",
    "data-name": "\\u30D1\\u30B9 146",
    d: "M69.853,80.732V49.4h23L89.108,73.937h26.741V93.588L82.3,93.265A12.549,12.549,0,0,1,69.853,80.732",
    transform: "translate(44.228 31.082)",
    fill: "#e9dfc6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_147",
    "data-name": "\\u30D1\\u30B9 147",
    d: "M69.853,80.732V49.4h23L89.108,73.937h26.741V93.588L82.3,93.265A12.549,12.549,0,0,1,69.853,80.732Z",
    transform: "translate(44.228 31.082)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_148",
    "data-name": "\\u30D1\\u30B9 148",
    d: "M70.427,26.985c-7.063,12.4-18.646,9.567-29.755-2.695L31.69,33.6c14.654,16.271,37.695,20.06,48.853,5.424",
    transform: "translate(20.065 15.282)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_149",
    "data-name": "\\u30D1\\u30B9 149",
    d: "M70.427,26.985c-7.063,12.4-18.646,9.567-29.755-2.695L31.69,33.6c14.654,16.271,37.695,20.06,48.853,5.424",
    transform: "translate(20.065 15.282)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_150",
    "data-name": "\\u30D1\\u30B9 150",
    d: "M128.457,68.305H61.639L54.865,43.916A19.388,19.388,0,0,1,71.757,19.443l.01,0A19.757,19.757,0,0,1,91.11,30.355c3.533,6.854,13.475,11.725,21.2,13.477,10.893,2.467,6.059,8.674,17.646,11.592a6.463,6.463,0,0,1,4.935,6.243v.218a6.429,6.429,0,0,1-6.436,6.421",
    transform: "translate(34.286 12.178)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_151",
    "data-name": "\\u30D1\\u30B9 151",
    d: "M128.457,68.305H61.639L54.865,43.916A19.388,19.388,0,0,1,71.757,19.443l.01,0A19.757,19.757,0,0,1,91.11,30.355c3.533,6.854,13.475,11.725,21.2,13.477,10.893,2.467,6.059,8.674,17.646,11.592a6.463,6.463,0,0,1,4.935,6.243v.218A6.429,6.429,0,0,1,128.457,68.305Z",
    transform: "translate(34.286 12.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_152",
    "data-name": "\\u30D1\\u30B9 152",
    d: "M67.3,19.356c38.5,1.338,42.294,38.343,8.424,40.774L72.012,47.645c16.235-1.067,14.158-11.491,3.345-13.415",
    transform: "translate(42.61 12.178)",
    fill: "#bbe0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_153",
    "data-name": "\\u30D1\\u30B9 153",
    d: "M67.3,19.356c38.5,1.338,42.294,38.343,8.424,40.774L72.012,47.645c16.235-1.067,14.158-11.491,3.345-13.415",
    transform: "translate(42.61 12.178)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_154",
    "data-name": "\\u30D1\\u30B9 154",
    d: "M72.532,21.457a9.928,9.928,0,1,0-9.928,9.9,9.917,9.917,0,0,0,9.928-9.9",
    transform: "translate(33.352 7.268)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_5",
    "data-name": "\\u6955\\u5186\\u5F62 5",
    cx: 9.928,
    cy: 9.904,
    rx: 9.928,
    ry: 9.904,
    transform: "translate(86.028 18.822)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_155",
    "data-name": "\\u30D1\\u30B9 155",
    d: "M72.866,49.4V61.9L65.1,69.719l1-1A18.938,18.938,0,0,0,71.339,58.5Z",
    transform: "translate(41.216 31.082)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_156",
    "data-name": "\\u30D1\\u30B9 156",
    d: "M72.866,49.4V61.9L65.1,69.719l1-1A18.938,18.938,0,0,0,71.339,58.5Z",
    transform: "translate(41.216 31.082)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_157",
    "data-name": "\\u30D1\\u30B9 157",
    d: "M54.15,15.169c3.493,4.827,6.139,6.453,10.519,6.453,9.505,0,4.356,4.6,13.864,4.558a132.682,132.682,0,0,1,16.325,1.181,4.2,4.2,0,1,0,1-8.335c-4.584-.5-8.51-.094-11.563-2.328-4.5-3.3-7.852-.412-13.639-3.3S59.13,10.134,54.15,15.169",
    transform: "translate(34.286 7.104)",
    fill: "#1a1311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_158",
    "data-name": "\\u30D1\\u30B9 158",
    d: "M54.15,15.169c3.493,4.827,6.139,6.453,10.519,6.453,9.505,0,4.356,4.6,13.864,4.558a132.682,132.682,0,0,1,16.325,1.181,4.2,4.2,0,1,0,1-8.335c-4.584-.5-8.51-.094-11.563-2.328-4.5-3.3-7.852-.412-13.639-3.3S59.13,10.134,54.15,15.169Z",
    transform: "translate(34.286 7.104)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_4",
    "data-name": "\\u7DDA 4",
    x1: 2.28,
    y2: 0.065,
    transform: "translate(89.56 29.184)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8",
    "data-name": "\\u9577\\u65B9\\u5F62 8",
    width: 5.276,
    height: 5.263,
    rx: 0.696,
    transform: "translate(84.212 26.737) rotate(-1.62)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u9577\\u65B9\\u5F62_9",
    "data-name": "\\u9577\\u65B9\\u5F62 9",
    d: "M.7,0H4.581a.695.695,0,0,1,.695.695V4.568a.695.695,0,0,1-.695.695H.695A.695.695,0,0,1,0,4.568V.7A.7.7,0,0,1,.7,0Z",
    transform: "translate(91.764 26.523) rotate(-1.62)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_159",
    "data-name": "\\u30D1\\u30B9 159",
    d: "M26.232,29.064c1.885,1.416,6.182,7.5,9.809,7.177l8.55-9.567s-5.218-4.44-10.243-5.8",
    transform: "translate(16.609 13.132)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_160",
    "data-name": "\\u30D1\\u30B9 160",
    d: "M26.232,29.064c1.885,1.416,6.182,7.5,9.809,7.177l8.55-9.567s-5.218-4.44-10.243-5.8",
    transform: "translate(16.609 13.132)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_161",
    "data-name": "\\u30D1\\u30B9 161",
    d: "M29.879,22.183l3.72,2.473a1.478,1.478,0,0,0,2.04-.409l.171-.256a1.471,1.471,0,0,0-.408-2.036l-3.72-2.471a1.476,1.476,0,0,0-2.04.407l-.171.257a1.47,1.47,0,0,0,.408,2.035",
    transform: "translate(18.504 12.104)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_211",
    "data-name": "\\u30D1\\u30B9 211",
    d: "M.9,0,2.343,0a.9.9,0,0,1,.9.9l.008,5.6a.9.9,0,0,1-.9.9l-1.448,0a.9.9,0,0,1-.9-.9L0,.9A.9.9,0,0,1,.9,0Z",
    transform: "translate(47.158 33.474) rotate(-56.321)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_162",
    "data-name": "\\u30D1\\u30B9 162",
    d: "M28.3,23.529,33.1,26.724a1.479,1.479,0,0,0,2.041-.407l.171-.257a1.47,1.47,0,0,0-.408-2.035L30.1,20.83a1.476,1.476,0,0,0-2.04.407l-.171.257a1.47,1.47,0,0,0,.408,2.035",
    transform: "translate(17.503 12.951)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_163",
    "data-name": "\\u30D1\\u30B9 163",
    d: "M28.3,23.529,33.1,26.724a1.479,1.479,0,0,0,2.041-.407l.171-.257a1.47,1.47,0,0,0-.408-2.035L30.1,20.83a1.476,1.476,0,0,0-2.04.407l-.171.257A1.47,1.47,0,0,0,28.3,23.529Z",
    transform: "translate(17.503 12.951)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_164",
    "data-name": "\\u30D1\\u30B9 164",
    d: "M27.191,25.191,32,28.386a1.479,1.479,0,0,0,2.041-.407l.171-.257a1.469,1.469,0,0,0-.408-2.035l-4.808-3.195a1.476,1.476,0,0,0-2.04.407l-.171.257a1.47,1.47,0,0,0,.408,2.035",
    transform: "translate(16.802 13.997)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_165",
    "data-name": "\\u30D1\\u30B9 165",
    d: "M27.191,25.191,32,28.386a1.479,1.479,0,0,0,2.041-.407l.171-.257a1.469,1.469,0,0,0-.408-2.035l-4.808-3.195a1.476,1.476,0,0,0-2.04.407l-.171.257A1.47,1.47,0,0,0,27.191,25.191Z",
    transform: "translate(16.802 13.997)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_166",
    "data-name": "\\u30D1\\u30B9 166",
    d: "M26.508,27.14l2.865,1.9a1.408,1.408,0,0,0,1.942-.388l.252-.376a1.4,1.4,0,0,0-.389-1.937l-2.866-1.9a1.405,1.405,0,0,0-1.942.388l-.25.375a1.4,1.4,0,0,0,.389,1.937",
    transform: "translate(16.39 15.23)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_212",
    "data-name": "\\u30D1\\u30B9 212",
    d: "M.856,0,2.389,0a.859.859,0,0,1,.857.858l.007,4.524a.853.853,0,0,1-.854.855l-1.535,0a.858.858,0,0,1-.856-.857L0,.857A.854.854,0,0,1,.856,0Z",
    transform: "translate(41.733 41.595) rotate(-56.317)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_167",
    "data-name": "\\u30D1\\u30B9 167",
    d: "M36.572,25.784c-.327-1.339-.733-1.14-3.1-1.867a1.755,1.755,0,0,1,.789-3.412c3.809.645,7.032,2.167,6.56,6.424l-1.837,2.051",
    transform: "translate(20.401 12.886)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_168",
    "data-name": "\\u30D1\\u30B9 168",
    d: "M36.572,25.784c-.327-1.339-.733-1.14-3.1-1.867a1.755,1.755,0,0,1,.789-3.412c3.809.645,7.032,2.167,6.56,6.424l-1.837,2.051",
    transform: "translate(20.401 12.886)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_169",
    "data-name": "\\u30D1\\u30B9 169",
    d: "M70.636,40.323c-1.313-.425-1.359.024-3.222,1.657a1.769,1.769,0,0,1-2.167.127,1.748,1.748,0,0,1-.33-2.587c2.548-2.9,5.538-4.835,8.925-2.2l.784,2.638",
    transform: "translate(40.831 22.697)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_170",
    "data-name": "\\u30D1\\u30B9 170",
    d: "M70.636,40.323c-1.313-.425-1.359.024-3.222,1.657a1.769,1.769,0,0,1-2.167.127,1.748,1.748,0,0,1-.33-2.587c2.548-2.9,5.538-4.835,8.925-2.2l.784,2.638",
    transform: "translate(40.831 22.697)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_171",
    "data-name": "\\u30D1\\u30B9 171",
    d: "M70.894,38.653l-8.148,3.208A1.528,1.528,0,0,0,62,43.883l.08.178a1.536,1.536,0,0,0,2.028.749l.4-.186-1.205.562a1.574,1.574,0,0,0-.772,2.082l.044.1a1.581,1.581,0,0,0,2.087.771l.921-.424-.918.432a1.57,1.57,0,0,0-.772,2.08l.044.1a1.577,1.577,0,0,0,2.086.769l1.112-.508,0,.008-.216.1a1.623,1.623,0,1,0,1.357,2.949l.428-.2c2.822-.728,8.994-1.39,10.459-4.316L75.487,36.845",
    transform: "translate(39.166 23.182)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_172",
    "data-name": "\\u30D1\\u30B9 172",
    d: "M70.894,38.653l-8.148,3.208A1.528,1.528,0,0,0,62,43.883l.08.178a1.536,1.536,0,0,0,2.028.749l.4-.186-1.205.562a1.574,1.574,0,0,0-.772,2.082l.044.1a1.581,1.581,0,0,0,2.087.771l.921-.424-.918.432a1.57,1.57,0,0,0-.772,2.08l.044.1a1.577,1.577,0,0,0,2.086.769l1.112-.508,0,.008-.216.1a1.623,1.623,0,1,0,1.357,2.949l.428-.2c2.822-.728,8.994-1.39,10.459-4.316L75.487,36.845",
    transform: "translate(39.166 23.182)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_173",
    "data-name": "\\u30D1\\u30B9 173",
    d: "M34.546,55.56c0-25.081-7.669-45.412-17.132-45.412S.284,30.479.284,55.56q0,3.38.183,6.631H34.362q.181-3.248.185-6.631",
    transform: "translate(0.18 6.384)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_174",
    "data-name": "\\u30D1\\u30B9 174",
    d: "M34.546,55.56c0-25.081-7.669-45.412-17.132-45.412S.284,30.479.284,55.56q0,3.38.183,6.631H34.362Q34.543,58.943,34.546,55.56Z",
    transform: "translate(0.18 6.384)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_175",
    "data-name": "\\u30D1\\u30B9 175",
    d: "M.4,42.092C1.608,64.029,8.732,80.873,17.343,80.873S33.08,64.029,34.291,42.092Z",
    transform: "translate(0.251 26.483)",
    fill: "#55458c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_176",
    "data-name": "\\u30D1\\u30B9 176",
    d: "M.4,42.092C1.608,64.029,8.732,80.873,17.343,80.873S33.08,64.029,34.291,42.092Z",
    transform: "translate(0.251 26.483)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_177",
    "data-name": "\\u30D1\\u30B9 177",
    d: "M.4,42.092C1.608,64.029,8.732,80.873,17.343,80.873S33.08,64.029,34.291,42.092Z",
    transform: "translate(0.251 26.483)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_178",
    "data-name": "\\u30D1\\u30B9 178",
    d: "M.4,42.092C1.608,64.029,8.732,80.873,17.343,80.873S33.08,64.029,34.291,42.092Z",
    transform: "translate(0.251 26.483)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_179",
    "data-name": "\\u30D1\\u30B9 179",
    d: "M15.7,10.147c-5.048,0-9.587,5.792-12.721,15,5.75,4.917,12.758.034,16.911,5.2s8.563,3.043,10.511,1.9c-2.994-13.237-8.457-22.1-14.7-22.1",
    transform: "translate(1.889 6.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_180",
    "data-name": "\\u30D1\\u30B9 180",
    d: "M15.7,10.147c-5.048,0-9.587,5.792-12.721,15,5.75,4.917,12.758.034,16.911,5.2s8.563,3.043,10.511,1.9C27.413,19.008,21.95,10.147,15.7,10.147Z",
    transform: "translate(1.889 6.384)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_181",
    "data-name": "\\u30D1\\u30B9 181",
    d: "M22.677,48.214A84.283,84.283,0,0,1,20.018,60.7a6.459,6.459,0,1,0,2.659-12.481",
    transform: "translate(12.675 30.335)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_182",
    "data-name": "\\u30D1\\u30B9 182",
    d: "M22.677,48.214A84.283,84.283,0,0,1,20.018,60.7a6.459,6.459,0,1,0,2.659-12.481Z",
    transform: "translate(12.675 30.335)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_183",
    "data-name": "\\u30D1\\u30B9 183",
    d: "M23.931,48.2a6.455,6.455,0,0,0-2.29,12.5A84.238,84.238,0,0,0,24.3,48.221c-.122-.007-.245-.018-.369-.018",
    transform: "translate(11.051 30.328)",
    fill: "#a64386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_184",
    "data-name": "\\u30D1\\u30B9 184",
    d: "M23.931,48.2a6.455,6.455,0,0,0-2.29,12.5A84.238,84.238,0,0,0,24.3,48.221C24.178,48.214,24.055,48.2,23.931,48.2Z",
    transform: "translate(11.051 30.328)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_185",
    "data-name": "\\u30D1\\u30B9 185",
    d: "M9.723,33.041a5.465,5.465,0,1,0,5.465-5.451,5.458,5.458,0,0,0-5.465,5.451",
    transform: "translate(6.156 17.359)",
    fill: "#fdce7d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_6",
    "data-name": "\\u6955\\u5186\\u5F62 6",
    cx: 5.465,
    cy: 5.451,
    rx: 5.465,
    ry: 5.451,
    transform: "translate(15.879 44.948)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_186",
    "data-name": "\\u30D1\\u30B9 186",
    d: "M29.417,12.983a3.712,3.712,0,1,0,3.712-3.7,3.708,3.708,0,0,0-3.712,3.7",
    transform: "translate(18.626 5.838)",
    fill: "#b965a1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_7",
    "data-name": "\\u6955\\u5186\\u5F62 7",
    cx: 3.712,
    cy: 3.703,
    rx: 3.712,
    ry: 3.703,
    transform: "translate(48.042 15.119)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12",
    "data-name": "\\u9577\\u65B9\\u5F62 12",
    width: 8.76,
    height: 8.739,
    transform: "translate(24.279 24.216)",
    fill: "#2b9d6e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13",
    "data-name": "\\u9577\\u65B9\\u5F62 13",
    width: 8.76,
    height: 8.739,
    transform: "translate(24.279 24.216)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_14",
    "data-name": "\\u9577\\u65B9\\u5F62 14",
    width: 4.321,
    height: 4.311,
    transform: "translate(56.942 99.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_15",
    "data-name": "\\u9577\\u65B9\\u5F62 15",
    width: 4.321,
    height: 4.311,
    transform: "translate(56.942 99.759)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_187",
    "data-name": "\\u30D1\\u30B9 187",
    d: "M26.079,78.147a4.215,4.215,0,1,0-4.215,4.2,4.211,4.211,0,0,0,4.215-4.2",
    transform: "translate(11.175 46.523)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_8",
    "data-name": "\\u6955\\u5186\\u5F62 8",
    cx: 4.215,
    cy: 4.205,
    rx: 4.215,
    ry: 4.205,
    transform: "translate(28.823 120.466)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_188",
    "data-name": "\\u30D1\\u30B9 188",
    d: "M64.909,103.925c-3.639-7.737-2.326-18.617,6.946-22.589,5.768,6.654,2.02,18.338,0,22.589Z",
    transform: "translate(39.909 51.175)",
    fill: "#47adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_189",
    "data-name": "\\u30D1\\u30B9 189",
    d: "M64.909,103.925c-3.639-7.737-2.326-18.617,6.946-22.589,5.768,6.654,2.02,18.338,0,22.589Z",
    transform: "translate(39.909 51.175)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    "data-name": "\\u30D1\\u30B9 190",
    d: "M69.468,101.874C66.949,95.558,71.473,87.837,77.89,84.6c3.993,5.433-2.216,13.809-3.614,17.279Z",
    transform: "translate(43.536 53.226)",
    fill: "#2b9d6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_191",
    "data-name": "\\u30D1\\u30B9 191",
    d: "M69.468,101.874C66.949,95.558,71.473,87.837,77.89,84.6c3.993,5.433-2.216,13.809-3.614,17.279Z",
    transform: "translate(43.536 53.226)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_192",
    "data-name": "\\u30D1\\u30B9 192",
    d: "M66.422,97.372c1.658-9.368,12.169-5.357,12.948,0Z",
    transform: "translate(42.056 57.728)",
    fill: "#2867a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_193",
    "data-name": "\\u30D1\\u30B9 193",
    d: "M66.422,97.372c1.658-9.368,12.169-5.357,12.948,0Z",
    transform: "translate(42.056 57.728)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_194",
    "data-name": "\\u30D1\\u30B9 194",
    d: "M75.225,98.714c-4.205-6.4-6.152-10.676-12.575-8.54s-4.606,8.54-4.606,8.54Z",
    transform: "translate(36.601 56.386)",
    fill: "#f9b137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_195",
    "data-name": "\\u30D1\\u30B9 195",
    d: "M75.225,98.714c-4.205-6.4-6.152-10.676-12.575-8.54s-4.606,8.54-4.606,8.54Z",
    transform: "translate(36.601 56.386)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_196",
    "data-name": "\\u30D1\\u30B9 196",
    d: "M80.593,94.26a4.15,4.15,0,1,0-4.15,4.14,4.146,4.146,0,0,0,4.15-4.14",
    transform: "translate(45.773 56.702)",
    fill: "#de543b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u6955\\u5186\\u5F62_9",
    "data-name": "\\u6955\\u5186\\u5F62 9",
    cx: 4.15,
    cy: 4.14,
    rx: 4.15,
    ry: 4.14,
    transform: "translate(118.066 146.821)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_5",
    "data-name": "\\u7DDA 5",
    y1: 3.561,
    x2: 7.731,
    transform: "translate(33.286 10.122)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_6",
    "data-name": "\\u7DDA 6",
    x2: 5.038,
    y2: 2.377,
    transform: "translate(34.725 99.759)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u7DDA_7",
    "data-name": "\\u7DDA 7",
    x2: 3.709,
    y2: 2.465,
    transform: "translate(45.047 53.311)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_197",
    "data-name": "\\u30D1\\u30B9 197",
    d: "M.283,37.561q.024,1.977.093,3.921H6.754A7.326,7.326,0,0,0,.283,37.561",
    transform: "translate(0.179 23.632)",
    fill: "#fdce7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_198",
    "data-name": "\\u30D1\\u30B9 198",
    d: "M.283,37.561q.024,1.977.093,3.921H6.754A7.326,7.326,0,0,0,.283,37.561Z",
    transform: "translate(0.179 23.632)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_199",
    "data-name": "\\u30D1\\u30B9 199",
    d: "M6.717,39.968H.34c.126,3.645.359,7.206.7,10.652a7.315,7.315,0,0,0,6.515-7.263,7.265,7.265,0,0,0-.838-3.389",
    transform: "translate(0.215 25.147)",
    fill: "#a64386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_200",
    "data-name": "\\u30D1\\u30B9 200",
    d: "M6.717,39.968H.34c.126,3.645.359,7.206.7,10.652a7.315,7.315,0,0,0,6.515-7.263A7.265,7.265,0,0,0,6.717,39.968Z",
    transform: "translate(0.215 25.147)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_201",
    "data-name": "\\u30D1\\u30B9 201",
    d: "M33.562,35.076a4.29,4.29,0,0,0,8.372,1.312,47.234,47.234,0,0,1-6.306-4.966,4.271,4.271,0,0,0-2.066,3.654",
    transform: "translate(21.25 19.77)",
    fill: "#b965a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_202",
    "data-name": "\\u30D1\\u30B9 202",
    d: "M33.562,35.076a4.29,4.29,0,0,0,8.372,1.312,47.234,47.234,0,0,1-6.306-4.966A4.271,4.271,0,0,0,33.562,35.076Z",
    transform: "translate(21.25 19.77)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_203",
    "data-name": "\\u30D1\\u30B9 203",
    d: "M37.051,31.038a4.278,4.278,0,0,0-2.223.624,46.909,46.909,0,0,0,6.306,4.967,4.28,4.28,0,0,0-4.083-5.591",
    transform: "translate(22.052 19.528)",
    fill: "#47adaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_204",
    "data-name": "\\u30D1\\u30B9 204",
    d: "M37.051,31.038a4.278,4.278,0,0,0-2.223.624,46.909,46.909,0,0,0,6.306,4.967,4.28,4.28,0,0,0-4.083-5.591Z",
    transform: "translate(22.052 19.528)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_205",
    "data-name": "\\u30D1\\u30B9 205",
    d: "M48.8,48.558a3.712,3.712,0,1,0-7.351.732h7.277a3.717,3.717,0,0,0,.073-.732",
    transform: "translate(26.199 28.222)",
    fill: "#f4bcaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_206",
    "data-name": "\\u30D1\\u30B9 206",
    d: "M48.8,48.558a3.712,3.712,0,1,0-7.351.732h7.277A3.717,3.717,0,0,0,48.8,48.558Z",
    transform: "translate(26.199 28.222)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_207",
    "data-name": "\\u30D1\\u30B9 207",
    d: "M41.422,47.577a3.714,3.714,0,0,0,7.277,0Z",
    transform: "translate(26.227 29.934)",
    fill: "#e97e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_208",
    "data-name": "\\u30D1\\u30B9 208",
    d: "M41.422,47.577a3.714,3.714,0,0,0,7.277,0Z",
    transform: "translate(26.227 29.934)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_209",
    "data-name": "\\u30D1\\u30B9 209",
    d: "M56.463,21.673H55.189a.766.766,0,0,1-.706-1.072,6.739,6.739,0,0,0,.639-2.035v-.6l1.124-.033",
    transform: "translate(34.455 11.283)",
    fill: "#fedbae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_210",
    "data-name": "\\u30D1\\u30B9 210",
    d: "M56.463,21.673H55.189a.766.766,0,0,1-.706-1.072,6.739,6.739,0,0,0,.639-2.035v-.6l1.124-.033",
    transform: "translate(34.455 11.283)",
    fill: "none",
    stroke: "#1a1311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineNotificationModalImage);
export default __webpack_public_path__ + "static/media/line-notification-modal__image.3e3b82c476312371d3d2bef373a4e5ce.svg";
export { ForwardRef as ReactComponent };